import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function Finanzierung() {
	return (
		<>
			<div className="beratung_cont" id="capital">
				<HelmetProvider>
					<Helmet>
						<title>Finanzierung Kapitalbeschaffung</title>
						<meta
							name="description"
							content="Finanzierung Kapitalbeschaffung"
						/>
						<meta
							name="keywords"
							content="Finanzierung,Kapitalbeschaffung, Feingeist, Berlin"
						/>
					</Helmet>
				</HelmetProvider>
				<h1>Beratung bei der Finanzierung / Kapitalbeschaffung</h1>
				<h2>Wir ermöglichen Wachstum</h2>
				<p>
					Die Feingeist Beratung begleitet Sie auf dem nächsten Schritt des
					Wachstums
				</p>
				<h2>Ihre Vorteile:</h2>
				<ul className="typeset-u-list">
					<li>Zugang zu verschiedenen Kapitalquellen</li>
					<li>
						Vermittlung von Eigen-, Mezzanin- oder Fremdkapital, je nach
						Situation und Bedarf
					</li>
					<li>Betreuung aus einer Hand bei Unternehmenskäufen</li>
				</ul>
				<p>
					Um das Wachstum durch Übernahmen zu forcieren werden diese oft durch
					neues Kapital finanziert. Die Feingeist Beratung kann
					Unternehmensakquisitionen und die Finanzierungs-konzepte aus einer
					Hand anbieten.
				</p>
				<p>Sprechen Sie uns an.</p>
			</div>
		</>
	);
}
